// extracted by mini-css-extract-plugin
export default {"gradient":"program_gradient__0gX3H"};